import {
  ChangeDetectionStrategy,
  Component,
  input,
  type OnInit,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslationModule } from '@fino-ui/translation';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-action-links',
  templateUrl: './action-links.component.html',
  styleUrl: './action-links.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule, RouterLink],
})
export class ActionLinksComponent implements OnInit {
  links = input<any[]>();
  productLink = input<string>();

  userRoles: string[] = [];

  constructor(private authService: KeycloakService) {}

  hasRole(role: string) {
    return this.userRoles.includes(role);
  }

  ngOnInit(): void {
    this.userRoles = this.authService.getUserRoles();
  }
}
